import {toClassroomIds} from 'client/TeacherDashboard/SkillPaths/hooks/skillPathEntryFilters';

import {automatedSkillPathsApi} from '../api/automatedSkillPathsApi';
import type {AutomatedSkillPathsFilter} from '../types';

import {useAsyncRequest} from './useAsyncRequest';

const skipCount = async (): Promise<undefined> => undefined;

/**
 * How many recommendations are outstanding in scope (one class, or every active class). Undefined
 * while it loads and while `isEnabled` is false, which skips the request.
 */
export const useRecommendedSkillsCount = (classroomId: string | undefined, isEnabled: boolean) =>
  useAsyncRequest<AutomatedSkillPathsFilter, number | undefined>(
    isEnabled ? automatedSkillPathsApi.recommendedSkillsCount : skipCount,
    {classroomIds: toClassroomIds(classroomId)}
  ).data;
